/* eslint-disable @typescript-eslint/no-explicit-any */
import { toastsDoNothing } from "@iventis/toasts/src/toast-do-nothing";
import { greyTheme, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import React, { useRef } from "react";

import { useTheme } from "@mui/material";
import { DataTableCallbackRefs } from "../types/data-table.types";
import { DataTable } from "./data-table";

export const DataTableTestingComponent = () => {
    const theme = useTheme<Theme>();
    const ref = useRef<DataTableCallbackRefs>();
    return (
        <StyledContainer style={{ height: "100vh", width: "100vw", position: "relative", display: "flex" }}>
            <DataTable<any>
                dataTableId="data-table-testing"
                ref={ref}
                columns={[
                    { agGridColumnProps: { field: "text-test", headerName: "Text test", editable: true } },
                    { agGridColumnProps: { field: "number-test", headerName: "Number test", cellEditor: "number" } },
                ]}
                gridOptions={{ rowData: [{ "text-test": "Hello", "number-test": 0 }], headerHeight: 44, rowHeight: 44, context: { toast: toastsDoNothing } }}
                theme={greyTheme(theme)}
            />
        </StyledContainer>
    );
};

const StyledContainer = styled.div`
    .ag-grid-iventis {
        height: 100%;
        width: 100%;
    }
`;

export default DataTableTestingComponent;
